<template>
    <div class="loader-overlay">
        <v-progress-circular
            :size="48"
            color="primary"
            indeterminate
        />
    </div>
</template>

<script>
export default {
    name: 'Loader',
    props: {},
    mixins: [],
    components: {},
    data() {
        return {}
    },
    computed: {},
    watch: {},
    methods: {},
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
}
</script>

<style scoped lang="sass">
.loader-overlay
    position: absolute
    inset: 0
    background-color: rgba(255, 255, 255, 0.7)
    display: grid
    place-items: center
    z-index: 9999
</style>
